import BaseModelAPI from '../BaseModelAPI';

export default class ProductionQualityInspectionDimension extends BaseModelAPI {
	static entity = 'productionqualityinspectiondimension';
	static entityName = 'productionqualityinspectiondimension';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.id = '';
		this.productionQualityInspectionNumber = '';
		this.workOrderProcessId = '';
		this.workOrderProcess = {};
		this.productionDate = '';
		this.productionQualityInspectionDimensionDetail = []
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		this.createdDate = '';
		/*END_APP_MODEL_DEFINITION*/
	}

}